/*!
    * @product/scmp-sdk 1.1.8
    * built by undefined
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-W6IDLDCZ.js.map
